import { render } from "./QuotaBalanceTab.vue?vue&type=template&id=27fd4a93&scoped=true"
import script from "./QuotaBalanceTab.vue?vue&type=script&lang=js"
export * from "./QuotaBalanceTab.vue?vue&type=script&lang=js"

import "./QuotaBalanceTab.vue?vue&type=style&index=0&id=27fd4a93&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fd4a93"]])

export default __exports__